<template>
  <div>
    <b-form-group>
      <label class="required-control">
        Cửa hàng:<b class="text-danger">*</b>
      </label>
      <treeselect
        ref="store-option"
        :load-options="loadOptionStores"
        :options="optionStores"
        :auto-load-root-options="false"
        :multiple="false"
        placeholder="Nhập cửa hàng"
        retryText="Thử lại..."
        retryTitle="Nhấp thử lại"
        loadingText="Đang tải..."
        noResultsText="Không có kết quả"
        :match-keys="['label', 'shortName']"
        v-model="order.storeId"
        @select="onSelectStore"
      />
      <b-form-invalid-feedback :state="validateState('searchStore')">
        Vui lòng nhập cửa hàng
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <label class="required-control">
        Nguồn đơn hàng:<b class="text-danger">*</b></label
      >
      <treeselect
        :load-options="loadOptionOrderSources"
        :options="optionOrderSources"
        :auto-load-root-options="false"
        :multiple="false"
        placeholder="Nhập nguồn đơn hàng"
        retryText="Thử lại..."
        retryTitle="Nhấp thử lại"
        loadingText="Đang tải..."
        noResultsText="Không có kết quả"
        :match-keys="['label']"
        :value="order.orderSourceName"
        v-model="order.orderSourceId"
        openDirection="bottom"
      />
      <b-form-invalid-feedback :state="validateState('searchStore')">
        Vui lòng nhập nguồn đơn hàng
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <label class="required-control">
        Loại đơn:<b class="text-danger">*</b>
      </label>
      <treeselect
        :options="optionTypes"
        :multiple="false"
        placeholder="Nhập loại đơn"
        noResultsText="Không có kết quả"
        :match-keys="['label', 'custom']"
        :value="order.orderType"
        v-model="order.orderType"
        openDirection="bottom"
      >
        <label
          slot="option-label"
          slot-scope="{ node, labelClassName }"
          :class="labelClassName"
        >
          <span :title="node.label"> {{ node.label }}</span>
        </label>
      </treeselect>
      <b-form-invalid-feedback :state="validateState('searchStore')">
        Vui lòng nhập nguồn đơn hàng
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="order.orderType === ENUM.TYPE_ORDER.EX_SHIPPING">
      <label class="required-control">
        Khu vực giao hàng:<b class="text-danger">*</b>
      </label>
      <treeselect
        :options="optionDeliveryArea"
        :multiple="false"
        placeholder="Chọn khu vực giao hàng"
        noResultsText="Không có kết quả"
        :match-keys="['label', 'custom']"
        v-model="order.deliveryArea"
        openDirection="bottom"
      >
        <label
          slot="option-label"
          slot-scope="{ node, labelClassName }"
          :class="labelClassName"
        >
          <span :title="node.label"> {{ node.label }}</span>
        </label>
      </treeselect>
      <b-form-invalid-feedback :state="validateState('deiveryArea')">
        Vui lòng chọn khu vực giao hàng
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="order.orderType === 4">
      <label class="required-control">
        Đơn vị vận chuyển:<b class="text-danger">*</b>
      </label>
      <treeselect
        :load-options="loadOptionShippingUnits"
        :options="optionShippingUnits"
        :auto-load-root-options="false"
        :multiple="false"
        placeholder="Nhập đơn vị vận chuyển"
        retryText="Thử lại..."
        retryTitle="Nhấp thử lại"
        loadingText="Đang tải..."
        noResultsText="Không có kết quả"
        v-model="order.shippingUnitId"
        openDirection="bottom"
      />
      <b-form-invalid-feedback :state="validateState('searchStore')">
        Vui lòng nhập đơn vị vận chuyển
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <label>Trạng thái đơn:<b class="text-danger">*</b></label>
      <treeselect
        :options="optionStatus"
        :multiple="false"
        placeholder="Nhập trạng thái đơn"
        noResultsText="Không có kết quả"
        :match-keys="['label', 'custom']"
        v-model="order.status"
        openDirection="bottom"
        @select="onSelectStatus"
      >
        <div slot="value-label" slot-scope="{ node }">
          {{ node.raw.customLabel }}
        </div>
      </treeselect>
    </b-form-group>

    <!-- Customer Classification - New Section -->
    <b-form-group v-if="showCustomerClassification">
      <label>Phân loại khách:<b class="text-danger">*</b></label>
      <treeselect
        :options="optionCustomerClassification"
        :multiple="false"
        placeholder="Chọn phân loại khách"
        noResultsText="Không có kết quả"
        :match-keys="['label', 'custom']"
        v-model="order.customerClassification"
        openDirection="bottom"
        @select="onSelectCustomerClassification"
      >
        <label
          slot="option-label"
          slot-scope="{ node, labelClassName }"
          :class="labelClassName"
        >
          <span :title="node.label"> {{ node.label }}</span>
        </label>
      </treeselect>
      <b-form-invalid-feedback
        :state="
          !(
            order.status === ENUM.ORDER_STATUS.UN_SUCCESS &&
            !order.customerClassification
          )
        "
      >
        Vui lòng nhập phân loại khách
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-show="showCancelStatus">
      <label>Lý do huỷ:<b class="text-danger">*</b></label>
      <treeselect
        :key="`cancel-status-${order.customerClassification}`"
        :options="getCancelStatusOptions()"
        :multiple="false"
        placeholder="Nhập lý do huỷ"
        noResultsText="Không có kết quả"
        :match-keys="['label', 'custom']"
        :value="order.cancelStatus"
        v-model="order.cancelStatus"
        openDirection="bottom"
      >
        <label
          slot="option-label"
          slot-scope="{ node, labelClassName }"
          :class="labelClassName"
        >
          <span :title="node.label"> {{ node.label }}</span>
        </label>
      </treeselect>
    </b-form-group>

    <b-form-group>
      <label>Trạng thái cuộc gọi:</label>
      <treeselect
        :options="optionCallStatus"
        :multiple="false"
        :clearable="false"
        placeholder="Chọn trạng thái cuộc gọi"
        noResultsText="Không có kết quả"
        :match-keys="['label', 'custom']"
        v-model="order.callStatus"
        openDirection="bottom"
      >
        <div slot="value-label" slot-scope="{ node }">
          {{ node.raw.customLabel }}
        </div>
      </treeselect>
    </b-form-group>

    <b-form-group>
      <label>Trạng thái thanh toán:</label>
      <treeselect
        :options="optionPaymentStatus"
        :multiple="false"
        placeholder="Nhập trạng thái đơn"
        noResultsText="Không có kết quả"
        :match-keys="['label', 'custom']"
        v-model="order.partnerPaymentStatus"
        openDirection="bottom"
      >
        <div slot="value-label" slot-scope="{ node }">
          {{ node.raw.customLabel }}
        </div>
      </treeselect>
    </b-form-group>

    <b-form-group>
      <label>Mã vận đơn</label>
      <b-form-input
        class="input-style"
        size="sm"
        v-model="order.codeShip"
        placeholder="Mã vận đơn"
        autocomplete="off"
      ></b-form-input>
    </b-form-group>

    <b-form-group>
      <label>Mã đơn từ sàn</label>
      <b-form-input
        class="input-style"
        size="sm"
        v-model.trim="order.orderSn"
        placeholder="Mã đơn từ sàn"
        autocomplete="off"
      ></b-form-input>
    </b-form-group>

    <b-form-group>
      <label>Mã Affiliate</label>
      <b-form-input
        class="input-style"
        size="sm"
        v-model="order.affiliateCode"
        placeholder="Mã vận đơn"
        autocomplete="off"
        :disabled="Boolean(tmpAffiliateCode)"
      ></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import linkMixin from '@/view/mixins/link.mixins.js';
import { validationMixin } from 'vuelidate';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import {
  CALL_STATUS_OPTIONS,
  CUSTOMER_CLASSIFICATION,
  DELIVERY_AREA_OPTIONS,
  ORDER_CANCEL_STATUS,
  ORDER_CANCEL_STATUS_CR,
  ORDER_CANCEL_STATUS_CUSTOMER_COME_TO_STORE,
  ORDER_CANCEL_STATUS_CUSTOMER_NOT_COME,
  ORDER_CANCEL_STATUS_DP,
  ORDER_CANCEL_STATUS_SHOP,
  ORDER_CANCEL_STATUS_SHOP_NOT_COME,
  ORDER_STATUS,
  ORDER_STATUS_CR,
  ORDER_STATUS_DP,
  ORDER_STATUS_SHOP,
  ORDER_TYPE,
  PAYMENT_STATUS,
} from '@/utils/constants';
import ENUM, { CALL_STATUS } from '@/utils/enum';
import {
  checkJobTitle,
  filterCancelReasonsForCRLeader,
  filterByRoles,
  getEmployeeFromLocal,
  reduceDataTreeSelect,
  removeAccents,
  shouldUseShopNotComeReasons,
} from '@/utils/common';
import { mapGetters } from 'vuex';
import { HANDLE_SET_ORDER_INFO } from '@/core/services/store/modules/order/order-info.module.js';

export default {
  mixins: [validationMixin, apiCommonMixin, linkMixin],
  props: {
    action: String,
  },
  components: {
    Treeselect,
  },
  data() {
    return {
      order: null,
      optionStores: null,
      optionOrderSources: null,
      optionTypes: null,
      optionDeliveryArea: null,
      optionShippingUnits: null,
      optionStatus: null,
      optionCancelStatus: null,
      optionPaymentStatus: null,
      optionCallStatus: null,
      optionCustomerClassification: null,
      userInfor: null,
      tmpAffiliateCode: null,
      originCheckTime: null,
      ENUM,
    };
  },
  watch: {
    order: {
      handler(value) {
        this.$store.dispatch(HANDLE_SET_ORDER_INFO, value);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['getOrderInfo']),
    checkCustomerCome() {
      return [3, 4].includes(Number(this.order.orderType));
    },
    isCheckDateAndTimeDisabled() {
      if (this.action === 'update') {
        if (this.originCheckDate && this.originCheckDate) {
          return true;
        }
      }
      return false;
    },
    showCustomerClassification() {
      return Number(this.order.status) === ENUM.ORDER_STATUS.UN_SUCCESS;
    },
    showCancelStatus() {
      const cancelStatuses = [
        ENUM.ORDER_STATUS.UN_SUCCESS,
        ENUM.ORDER_STATUS.SYSTEM_CANCEL,
        ENUM.ORDER_STATUS.CR_CANCEL,
      ];
      return cancelStatuses.includes(Number(this.order.status));
    },
  },
  created() {
    this.mappingEnum();

    this.order = this.getOrderInfo;

    if (this.order.callStatus === undefined || this.order.callStatus === null) {
      this.order.callStatus = CALL_STATUS.NOT_CALLED;
    }

    if (this.action === 'update') {
      this.optionStores = [
        {
          id: this.getOrderInfo.storeId,
          label: this.getOrderInfo.storeName,
        },
      ];

      this.optionOrderSources = [
        {
          id: this.getOrderInfo.orderSourceId,
          label: this.getOrderInfo.orderSourceName,
        },
      ];
      const status = this.getOrderInfo.status || null;
      const statusName = this.getOrderInfo.statusName || null;
      const hasStatus = this.optionStatus.find(
        (o) => status && Number(o.id) === status,
      );

      if (!hasStatus) {
        this.optionStatus.unshift({
          id: status,
          label: statusName,
          custom: removeAccents(statusName),
          customLabel: statusName,
        });
      }
      if (this.order.checkDate && this.order.checkTime) {
        this.originCheckDate = this.order.checkDate;
        this.originCheckTime = this.order.checkTime;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.optionStores = null;
      this.optionOrderSources = null;
      this.loadOptionShippingUnits();
      if (this.order.affiliateCode) {
        this.tmpAffiliateCode = this.order.affiliateCode;
      }
    });
  },
  methods: {
    onSelectStore(node) {
      if (node.id && node.id !== this.order.storeId) {
        this.order.storeId = node.id;
        this.order.storeName = node.label;
      } else {
        this.order.storeId = null;
        this.order.storeName = null;
      }
    },
    onSelectShippingUnit(node) {
      if (node.id && node.id !== this.order.shippingUnitId) {
        this.order.shippingUnitId = node.id;
      } else {
        this.order.shippingUnitId = null;
      }
    },
    onSelectStatus(node) {
      if (node.id !== ENUM.ORDER_STATUS.UN_SUCCESS) {
        this.order.customerClassification = null;
        this.order.customerClassificationName = null;
      }

      const cancelStatuses = [
        ENUM.ORDER_STATUS.UN_SUCCESS,
        ENUM.ORDER_STATUS.SYSTEM_CANCEL,
        ENUM.ORDER_STATUS.CR_CANCEL,
      ];

      if (!cancelStatuses.includes(node.id)) {
        this.order.cancelStatus = null;
        this.order.cancelStatusName = null;
      }
    },

    onSelectCustomerClassification(node) {
      if (node.id && node.id !== this.order.customerClassification) {
        this.order.customerClassification = node.id;
        this.order.customerClassificationName = node.label;
        this.order.cancelStatus = null;
        this.order.cancelStatusName = null;
      } else {
        this.order.customerClassification = null;
        this.order.customerClassificationName = null;
      }
    },
    mappingEnum() {
      this.userInfor = getEmployeeFromLocal();
      // Bỏ đi loại đơn website và shop khi ở create mode
      this.optionTypes = reduceDataTreeSelect(ORDER_TYPE, 'id', 'name').filter(
        (item) =>
          item.id !== ENUM.TYPE_ORDER.WEBSITE &&
          item.id !== ENUM.TYPE_ORDER.SHOP,
      );

      this.optionStatus = this.getStatusByJobTitle();

      this.optionCancelStatus = reduceDataTreeSelect(
        ORDER_CANCEL_STATUS,
        'value',
        'text',
      );

      this.optionPaymentStatus = reduceDataTreeSelect(
        PAYMENT_STATUS,
        'id',
        'name',
      );

      this.optionDeliveryArea = reduceDataTreeSelect(
        DELIVERY_AREA_OPTIONS,
        'value',
        'text',
      );
      // Trạng thái cuộc gọi
      this.optionCallStatus = CALL_STATUS_OPTIONS;

      // Phân loại khách hàng
      this.optionCustomerClassification = this.transformToTreeselectOptions(
        CUSTOMER_CLASSIFICATION,
      );
    },
    transformToTreeselectOptions(items) {
      return items.reduce((result, element) => {
        if (element.value !== null) {
          result.push({
            id: Number(element.value),
            label: element.text,
            custom: element.text.toLowerCase().replace(/\s+/g, ''),
            customLabel: element.text,
            originalValue: element.value,
          });
        } else {
          result.push({
            id: -1,
            label: element.text,
            custom: element.text.toLowerCase(),
            customLabel: element.text,
            originalValue: null,
          });
        }
        return result;
      }, []);
    },
    getStatusByJobTitle() {
      const jobTitleId = this.userInfor.jobTitleId;

      if (checkJobTitle().isCR(jobTitleId)) {
        return reduceDataTreeSelect(ORDER_STATUS_CR, 'value', 'text');
      } else if (checkJobTitle().isShop(jobTitleId)) {
        return reduceDataTreeSelect(ORDER_STATUS_SHOP, 'value', 'text');
      } else if (checkJobTitle().isDP(jobTitleId)) {
        return reduceDataTreeSelect(ORDER_STATUS_DP, 'value', 'text');
      } else {
        return reduceDataTreeSelect(ORDER_STATUS, 'value', 'text');
      }
    },
    getCancelStatusOptions() {
      if (
        Number(this.order.status) === Number(ENUM.ORDER_STATUS.UN_SUCCESS) &&
        this.order.customerClassification
      ) {
        return this.getCustomerCancelOptions(this.order.customerClassification);
      }
      return this.transformToTreeselectOptions(
        this.getCancelStatusByJobTitle(),
      );
    },

    getCustomerCancelOptions(customerClassification) {
      let cancelOptions = [];
      const jobTitleId = this.userInfor.jobTitleId;
      // SHOP + "Khách không đến": dùng bộ lý do huỷ chuyên biệt
      if (shouldUseShopNotComeReasons(jobTitleId, customerClassification)) {
        return this.transformToTreeselectOptions(
          filterCancelReasonsForCRLeader(
            ORDER_CANCEL_STATUS_SHOP_NOT_COME,
            jobTitleId,
          ),
        );
      }
      const roleName = [];

      if (customerClassification) {
        if (
          Number(customerClassification) ===
          Number(ENUM.CUSTOMER_CLASSIFICATION_TYPE.NOT_COME)
        ) {
          // Khách không đến
          cancelOptions = ORDER_CANCEL_STATUS_CUSTOMER_NOT_COME;
        } else if (
          Number(customerClassification) ===
          Number(ENUM.CUSTOMER_CLASSIFICATION_TYPE.COME_TO_STORE)
        ) {
          // Khách đến CH
          cancelOptions = ORDER_CANCEL_STATUS_CUSTOMER_COME_TO_STORE;
        }
      }

      if (checkJobTitle().isCR(jobTitleId)) {
        roleName.push('CR');
      } else if (checkJobTitle().isShop(jobTitleId)) {
        roleName.push('SHOP');
      } else if (checkJobTitle().isDP(jobTitleId)) {
        roleName.push('DP');
      }

      if (roleName.length > 0) {
        cancelOptions = filterByRoles(cancelOptions, roleName);
      }

      cancelOptions = filterCancelReasonsForCRLeader(
        cancelOptions,
        jobTitleId,
      );

      return this.transformToTreeselectOptions(cancelOptions);
    },

    getCancelStatusByJobTitle() {
      const jobTitleId = this.userInfor.jobTitleId;
      let cancelStatus;

      if (checkJobTitle().isCR(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_CR;
      } else if (checkJobTitle().isShop(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_SHOP;
      } else if (checkJobTitle().isDP(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_DP;
      } else {
        cancelStatus = ORDER_CANCEL_STATUS;
      }

      return filterCancelReasonsForCRLeader(cancelStatus, jobTitleId);
    },

    validateState(name) {
      if (!name) return null;
      //   const { $dirty, $error } = this.$v[name];
      //   return $dirty ? !$error : null;
    },
    async loadOptionStores() {
      const result = await this.fetchStores();

      this.optionStores = this.mapDataTreeSelect(result.data, [
        'id',
        'name',
        'shortName',
      ]);
    },

    async loadOptionShippingUnits() {
      const result = await ApiService.get('/shipping-unit/select?status=1');

      this.optionShippingUnits = this.mapDataTreeSelect(result.data.data, [
        'id',
        'name',
      ]);
    },

    async loadOptionOrderSources() {
      const result = await this.fetchOrderSources();
      this.optionOrderSources = this.mapDataTreeSelect(result.data, [
        'id',
        'name',
      ]);
    },
    mapDataTreeSelect(items = [], keys = []) {
      return items.map((element) => {
        return {
          id: element[keys[0]],
          label: element[keys[1]],
          shortName: element[keys[2]],
        };
      });
    },
  },
};
</script>
